import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { permissionGuard } from './shared/guards/permisson-guard';
import { publicOnlyGuard } from './core/guards/public-only-guard';
import { stagingOnlyGuard } from './core/guards/staging-only-guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/validity-check/validity-check').then(
        m => m.ValidityCheck
      ),
  },
  {
    path: 'auth-callback',
    loadComponent: () =>
      import('./features/auth-callback/auth-callback').then(
        m => m.AuthCallback
      ),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'no-access',
    loadComponent: () =>
      import('./features/no-access/no-access').then(m => m.NoAccess),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'late-submission',
    loadComponent: () =>
      import('./features/public-page/public-page').then(m => m.PublicPage),
    canActivate: [publicOnlyGuard, stagingOnlyGuard],
  },
  {
    path: 'validityCheck',
    loadComponent: () =>
      import('./features/public-page/public-page').then(m => m.PublicPage),
    canActivate: [publicOnlyGuard, stagingOnlyGuard],
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./features/public-page/public-page').then(m => m.PublicPage),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/dashboard').then(m => m.Dashboard),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'vision',
    children: [
      {
        path: 'registration',
        loadComponent: () =>
          import('./features/vision/vision-registration/vision-registration').then(
            m => m.VisionRegistration
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'person',
        loadComponent: () =>
          import('./shared/components/professional-person/professional-person-overview/professional-person-overview').then(
            m => m.ProfessionalPersonOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'person/:id',
        loadComponent: () =>
          import('./shared/components/professional-person/professional-person-edit/professional-person-edit').then(
            m => m.ProfessionalPersonEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'optician',
        loadComponent: () =>
          import('./features/vision/optician/optician-overview/optician-overview').then(
            m => m.OpticianOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'optician/:id',
        loadComponent: () =>
          import('./shared/components/company/company-edit/company-edit').then(
            m => m.CompanyEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'late-submission',
        loadComponent: () =>
          import('./shared/components/late-submission/late-submission-overview/late-submission-overview').then(
            m => m.LateSubmissionOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'late-submission/new',
        loadComponent: () =>
          import('./shared/components/late-submission/late-submission').then(
            m => m.Latesubmission
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'late-submission/:id',
        loadComponent: () =>
          import('./shared/components/late-submission/late-submission-check/late-submission-check').then(
            m => m.LateSubmissionCheck
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'test-result',
        loadComponent: () =>
          import('./features/vision/vision-test-result-overview/vision-test-result-overview').then(
            m => m.VisionTestResultOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'test-result/:id',
        loadComponent: () =>
          import('./features/vision/vision-test-result-edit/vision-test-result-edit').then(
            m => m.VisionTestResultEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
    ],
  },
  {
    path: 'firstaid',
    children: [
      {
        path: 'registration',
        loadComponent: () =>
          import('./features/firstaid/course-provider/course-provider-certification/course-provider-certification').then(
            m => m.CourseProviderCertification
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'recertification',
        loadComponent: () =>
          import('./features/firstaid/course-provider/course-provider-certification/course-provider-certification').then(
            m => m.CourseProviderCertification
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'application',
        loadComponent: () =>
          import('./features/firstaid/application/application-overview/application-overview').then(
            m => m.ApplicationOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'application/:id',
        loadComponent: () =>
          import('./features/firstaid/application/application-check/application-check').then(
            m => m.ApplicationCheck
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'courseprovider',
        loadComponent: () =>
          import('./features/firstaid/course-provider/course-provider-overview/course-provider-overview').then(
            m => m.CourseProviderOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'courseprovider/:id',
        loadComponent: () =>
          import('./shared/components/company/company-edit/company-edit').then(
            m => m.CompanyEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'disposition/:id',
        loadComponent: () =>
          import('./features/firstaid/disposition-check/disposition-check').then(
            m => m.DispositionCheck
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'person',
        loadComponent: () =>
          import('./shared/components/professional-person/professional-person-overview/professional-person-overview').then(
            m => m.ProfessionalPersonOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'person/:id',
        loadComponent: () =>
          import('./shared/components/professional-person/professional-person-edit/professional-person-edit').then(
            m => m.ProfessionalPersonEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'courseaddress',
        loadComponent: () =>
          import('./features/firstaid/course-address/course-address-overview/course-address-overview').then(
            m => m.CourseAddressOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'courseaddress/:id',
        loadComponent: () =>
          import('./features/firstaid/course-address/course-address-edit/course-address-edit').then(
            m => m.CourseAddressEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'participant',
        loadComponent: () =>
          import('./features/firstaid/participant/participant-overview/participant-overview').then(
            m => m.ParticipantOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'participant/:id',
        loadComponent: () =>
          import('./features/firstaid/participant/participant-edit/participant-edit').then(
            m => m.ParticipantEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'coursegroup',
        loadComponent: () =>
          import('./features/firstaid/course-group/course-group-overview/course-group-overview').then(
            m => m.CourseGroupOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'coursegroup/:id',
        loadComponent: () =>
          import('./features/firstaid/course-group/course-group-edit/course-group-edit').then(
            m => m.CourseGroupEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'coursetype',
        loadComponent: () =>
          import('./features/firstaid/course-type/course-type-overview/course-type-overview').then(
            m => m.CourseTypeOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'coursetype/:id',
        loadComponent: () =>
          import('./features/firstaid/course-type/course-type-edit/course-type-edit').then(
            m => m.CourseTypeEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'late-submission',
        loadComponent: () =>
          import('./shared/components/late-submission/late-submission-overview/late-submission-overview').then(
            m => m.LateSubmissionOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'late-submission/new',
        loadComponent: () =>
          import('./shared/components/late-submission/late-submission').then(
            m => m.Latesubmission
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'late-submission/:id',
        loadComponent: () =>
          import('./shared/components/late-submission/late-submission-check/late-submission-check').then(
            m => m.LateSubmissionCheck
          ),
        canActivate: [authGuard, permissionGuard],
      },
    ],
  },
  {
    path: 'admin',
    children: [
      {
        path: 'auditlog',
        loadComponent: () =>
          import('./features/admin/audit-log/audit-log-overview/audit-log-overview').then(
            m => m.AuditLogOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'status',
        loadComponent: () =>
          import('./features/admin/service-status-info/service-status-info-overview/service-status-info-overview').then(
            m => m.ServiceStatusInfoOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'liechtenstein-certificate',
        loadComponent: () =>
          import('./features/admin/liechtenstein-certificate/liechtenstein-certificate-overview/liechtenstein-certificate-overview').then(
            m => m.LiechtensteinCertificateOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'billing-event',
        loadComponent: () =>
          import('./features/admin/billing-event/billing-event-overview/billing-event-overview').then(
            m => m.BillingEventOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'billing-event/transmissions',
        loadComponent: () =>
          import('./features/admin/billing-event/abacus-transmission-overview/abacus-transmission-overview').then(
            m => m.AbacusTransmissionOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'api-token',
        loadComponent: () =>
          import('./features/admin/api-token/api-token-overview/api-token-overview').then(
            m => m.ApiTokenOverview
          ),
        canActivate: [authGuard, permissionGuard],
      },
      {
        path: 'api-token/:id',
        loadComponent: () =>
          import('./features/admin/api-token/api-token-edit/api-token-edit').then(
            m => m.ApiTokenEdit
          ),
        canActivate: [authGuard, permissionGuard],
      },
    ],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./features/profile/profile').then(m => m.Profile),
    canActivate: [authGuard],
  },
];
